export class KvSize {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      if (document.getElementById('js-kv_movie') == null) return
      const kv = document.querySelector('.p-index_kv')
      const movie = document.getElementById('js-kv_movie')
      if (window.innerWidth >= 768) return
      const resize = () => {
        let textH = document.querySelector('.p-index_kv__text').clientHeight
        let newsH = document.querySelector('.p-index_kv__news').clientHeight
        let movieH = window.innerHeight - (textH + newsH)
        kv.style.height = window.innerHeight + 'px'
        movie.style.height = movieH + 'px'
      }
      resize()
      window.addEventListener('load', resize)
      window.addEventListener('orientationchange', () => {
        setTimeout(resize, 50)
      })
    })
  }
}
